<template>
  <section class="checkout-payment-select open">
    <h2 class="payment-term-header expandable-header">
      <!-- Your Payments -->
      {{ $t("checkout.payment.choosePaymentTerms") }}
    </h2>

    <div class="payment-select">
      <select
        v-model="paymentCount"
        class="form-control"
        @change="updatePaymentCount()"
      >
        <option
          v-for="p in paymentTermsForSelect"
          :key="p.value"
          :value="p.value"
        >
          {{ p.text }}
        </option>
      </select>

      <div
        v-if="ers"
        class="errors"
      >
        <span>{{ ers }}</span>
        <span
          class="delete"
          @click="ers = null"
        />
      </div>
    </div>
  </section>
</template>

<script>
import Api from '../cart_api'
import { mapMutations } from 'vuex'

export default {
  props: ['options', 'orderpaymentcount', 'order'],

  data() {
    return {
      ers: null,
      paymentCount: 1,
    }
  },
  computed: {
    paymentTermsForSelect() {
      return this.options.map((option) => {
        return { text: this.$t(`payment_term_${option}`), value: option }
      })
    },
  },
  watch: {
    orderpaymentcount() {
      this.paymentCount = this.orderpaymentcount
    },
  },

  created() {
    this.paymentCount = this.orderpaymentcount
  },

  methods: {
    ...mapMutations('checkout', ['updatePaymentFields']),
    updatePaymentCount() {
      Api.changeOrder(
        JSON.stringify({ order: { payment_count: this.paymentCount } }),
        false
      ).then((order) => {
        this.updatePaymentFields({ amount: order.amount_due_today })
        this.$emit('order')
        if (order.id == undefined) {
          this.paymentCount = this.orderpaymentcount
          this.ers = this.$t('packageNotUpdated')
        }
      })
    },
  },
}
</script>
